import { FormEventHandler, useContext, useState } from 'react';
import { AppContext } from 'providers/AppProvider';
import { formatErrors, getFormValues, logger, UserParams, validateAuthEmployeeForm, validateAuthForm } from 'helpers';
import { HandleUserForm } from './AuthenticateHelpers';
import { useAMLStatus } from 'hooks/useAMLStatus';

const SHOW_COSTS_FOR_FLOW_TYPES: { [key: string]: boolean } = { eb: true, er: true, mv: true };

export function useAuthenticate() {
	useAMLStatus();

	const ctx = useContext(AppContext);
	const { config, t } = ctx;
	const { IS_EMPLOYEE_WEB } = config;
	const { companyKennitala } = UserParams();
	const [isManualSignCompany, setIsManualSignCompany] = useState(!!companyKennitala);
	const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});

	const onSubmit: FormEventHandler<HTMLFormElement> = e => {
		e.preventDefault();
		e.stopPropagation();
		const formValues = getFormValues(e.currentTarget);
		const errors = (IS_EMPLOYEE_WEB ? validateAuthEmployeeForm : validateAuthForm)(formValues);
		if (Object.keys(errors).length) {
			setFormErrors(formatErrors(errors, t));
			logger('ERROR_MESSAGE', formValues, errors);
		} else {
			setFormErrors({});
			HandleUserForm(ctx, formValues);
		}
	};

	return {
		...ctx,
		formErrors,
		isManualSignCompany,
		onSubmit,
		setIsManualSignCompany,
		SHOW_COSTS_FOR_FLOW_TYPES
	};
}
